var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16667 12.3252C7.78833 12.3252 6.66667 11.2192 6.66667 9.86014C6.66667 8.50108 7.78833 7.3951 9.16667 7.3951H13.3333V2.25962C13.3333 1.01313 12.3058 0 11.0417 0H2.29167C1.0275 0 0 1.01313 0 2.25962V17.4607C0 18.7072 1.0275 19.7203 2.29167 19.7203H11.0417C12.3058 19.7203 13.3333 18.7072 13.3333 17.4607V12.3252H9.16667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5141 13.9061C15.2032 13.7787 14.9999 13.4788 14.9999 13.1468V10.6818H9.16658C8.70659 10.6818 8.33325 10.3137 8.33325 9.86013C8.33325 9.40656 8.70659 9.03845 9.16658 9.03845H14.9999V6.57342C14.9999 6.24146 15.2032 5.94155 15.5141 5.81419C15.8257 5.68683 16.1841 5.75749 16.4224 5.99249L19.7557 9.2792C20.0816 9.60048 20.0816 10.1198 19.7557 10.4411L16.4224 13.7278C16.1841 13.9628 15.8257 14.0334 15.5141 13.9061Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.7203,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.33f825da.svg";
export { ForwardRef as ReactComponent };